<template>
    <div>
        
          <div class="col-md-12">
              <h3>Relatório Analítico campanha</h3>
              <table id="relLog" ref='tabela' class="table display table-hover table-striped"  style="width: 100%">
                  <thead></thead>
                  <tbody></tbody>
                  <tfoot></tfoot>
              </table>
          </div>
    </div>
  </template>
  
  <script>

  import validarTel from '../../store/modules/validarTel';
  export default {
      props:{
          filter: {
              type: String,
              default: ''
          }
      },
      data(){
          return {
              dt: null,
              val: this.filter
          }
      },
      watch:{
          filter: {
              handler: function(val){
                  this.createTable()
              },
              deep: true
          }
      },
      methods:{
          createTable(){
  
              if (this.dt){
                  $('#relLog').DataTable().destroy();
              }
  
              console.log('filter', this.filter);
  
              this.dt = $('#relLog').DataTable({
                  ajax:{
                      url: '/marketing/log',
                      data: { param: this.filter },
                      dataSrc: ''
                  },
                  
                  columns: [{
                      data: 'nome_campanha',
                      class: 'tamanho',
                      title: 'Campanha'
                  },
                  {
                      data: 'telefone',
                      class: 'tamanho',
                      title: 'Telefone',
                      render: function ( data, type, row, meta ) {
                            return validarTel.formata_telefone(data);
                        }
                  },
                  {
                      data: 'name',
                      class: 'tamanho',
                      title: 'Cliente'
                  },
                  {
                      data: 'status',
                      class: 'tamanho',
                      title: 'Status'
                  }]
                  
              });
              console.log('DATA: ',this.data);
  
              this.dt.buttons('.dtUpdateButton').remove();
          }
      },
      mounted(){
          this.createTable();
  
      }
  
  }
  </script>
  
  <style scoped>
  .tamanho{
      width: 300px;
  }
  </style>